import './SelectTimes.scss'
import React, { PureComponent } from 'react'
import classnames from 'classnames'
import InputWrapper from './InputWrapper'
import SelectTime from './SelectTime'
import Switch from './Switch'

class SelectTimes extends PureComponent {
  render() {
    const { value, onChange, className, ...rest } = this.props
    return (
      <InputWrapper {...rest} className={classnames('SelectTimes', className)}>
        <Switch
          inline
          value={!value || !value.disabled}
          onChange={toggled => onChange(Object.assign({}, value, { disabled: !toggled }))}
        />
        <SelectTime {...rest}
          max={value && value.to}
          value={value && value.from}
          onChange={from => onChange(Object.assign({}, value, { from }))}
        />
        <span>–</span>
        <SelectTime {...rest}
          min={value && value.from}
          value={value && value.to}
          onChange={to => onChange(Object.assign({}, value, { to }))}
        />
      </InputWrapper>
    )
  }
}

SelectTimes.displayName = 'SelectTimes'

export default SelectTimes



// WEBPACK FOOTER //
// ./src/lib/form/SelectTimes.js